// @ts-nocheck

export const localeCodes =  [
  "en",
  "es",
  "zh-cn",
  "de",
  "fr",
  "pl"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_953d5676",
      load: () => import("#nuxt-i18n/953d5676" /* webpackChunkName: "locale_en_46json_953d5676" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_dc3edb96",
      load: () => import("#nuxt-i18n/dc3edb96" /* webpackChunkName: "locale_es_46json_dc3edb96" */),
      cache: true
    }
  ],
  "zh-cn": [
    {
      key: "locale_zh_45cn_46json_5cee4227",
      load: () => import("#nuxt-i18n/5cee4227" /* webpackChunkName: "locale_zh_45cn_46json_5cee4227" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_570bbfcd",
      load: () => import("#nuxt-i18n/570bbfcd" /* webpackChunkName: "locale_de_46json_570bbfcd" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_b8d66af1",
      load: () => import("#nuxt-i18n/b8d66af1" /* webpackChunkName: "locale_fr_46json_b8d66af1" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_4f7326c7",
      load: () => import("#nuxt-i18n/4f7326c7" /* webpackChunkName: "locale_pl_46json_4f7326c7" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    iso: "en-US",
    name: "English",
    language: undefined
  },
  {
    code: "es",
    iso: "es-MX",
    name: "Español",
    language: undefined
  },
  {
    code: "zh-cn",
    iso: "zh-CN",
    name: "中文",
    language: undefined
  },
  {
    code: "de",
    iso: "de",
    name: "Deutsch",
    language: undefined
  },
  {
    code: "fr",
    iso: "fr",
    name: "Français",
    language: undefined
  },
  {
    code: "pl",
    iso: "pl",
    name: "Polski",
    language: undefined
  }
]

